export default "__VITE_ASSET__B$ZztHN4__"